import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

// Routes
import developing from "./routes-developing";
import AuthRequired from "@/utils/auth-required";

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0}
  }
});

// Vue app instance;
// eslint-disable-next-line no-unused-vars
const $vm = router.app;

const routes = [
  ...developing,
  {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
    path: '',
    component: () => import('@/layouts/main/Main.vue'),
    beforeEnter: AuthRequired,
    children: [
      // =============================================================================
      // Theme Routes
      // =============================================================================
      // Home
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/Home/index.vue'),
        meta: {
          breadcrumb: [
            { title: { i18n: 'sections.home.title', default: "Home" }, url: '/', active: true }
          ],
          pageTitle: 'sections.home.title',
        }
      },

      // Profile
      {
        path: '/profile',
        name: 'profile',
        component: () => import('@/views/pages/Profile/index.vue'),
        meta: {
          breadcrumb: [
            { title: { i18n: 'sections.profile.title', default: "Profile" }, url: '/', active: true }
          ],
          pageTitle: 'Profile',
        }
      },

      // Class Overview
      {
        path: 'class-over-view/:classRoomId',
        name: 'class-over-view',
        props: true,
        component: () => import('@/views/pages/ClassOverview/index.vue'),
        meta: {
          breadcrumb: [
            {title: 'Home', url: '/'},
            {
              title: {i18n: 'sections.class-over-view.page-title', default: "จัดการห้องเรียน"},
              active: true
            }
          ],
          pageTitle: 'sections.class-over-view.page-title',
        },
      },

      // Classroom Stats
      {
        path: 'classroom-stats/:classroomId',
        name: 'classroom-stats',
        props: true,
        component: () => import('@/developing/views/pages/ClassroomStats/index.vue'),
        meta: {
          breadcrumb: [
            {title: 'Home', url: '/'},
            {
              title: {i18n: 'sections.classroom-stats.page-title', default: "สถิติห้องเรียน"},
              active: true
            }
          ],
          pageTitle: 'sections.classroom-stats.page-title',
        },
      },

      // Student Assignment
      {
        path: 'student-assignment/:classSectionId',
        name: 'student-assignment',
        props: true,
        component: () => import('@/views/pages/Teacher/StudentAssignment/index.vue'),
        meta: {
          breadcrumb: [
            {title: 'Home', url: '/'},
            {
              title: {i18n: 'sections.student-assignment.page-title', default: "บันทึกผลการส่งงาน"},
              active: true
            }
          ],
          pageTitle: 'sections.student-assignment.page-title',
        },
      },

      // Student Score
      {
        path: 'student-score/:classSectionId',
        name: 'student-score',
        props: true,
        component: () => import('@/views/pages/Teacher/StudentScore/index.vue'),
        meta: {
          breadcrumb: [
            {title: 'Home', url: '/'},
            {
              title: {i18n: 'sections.student-score.page-title', default: "บันทึกคะแนน"},
              active: true
            }
          ],
          pageTitle: 'sections.student-score.page-title',
        },
      },

      // Student Stats
      {
        path: 'student-stats/:classSectionId',
        name: 'student-stats',
        props: true,
        component: () => import('@/views/pages/Teacher/StudentStats/index.vue'),
        meta: {
          breadcrumb: [
            {title: 'Home', url: '/'},
            {
              title: {i18n: 'sections.student-stats.page-title', default: "สถิติการเข้าเรียน"},
              active: true
            }
          ],
          pageTitle: 'sections.student-stats.page-title',
        },
      },

      // Course FAQ
      {
        path: 'course-faq/:classSectionId/:courseOutlineId',
        name: 'course-faq',
        props: true,
        component: () => import('@/views/pages/Teacher/CourseFaq/index.vue'),
        meta: {
          breadcrumb: [
            {title: 'Home', url: '/'},
            {
              title: {i18n: 'sections.course-faq.page-title', default: "FAQ ประจำวิชา"},
              active: true
            }
          ],
          pageTitle: 'sections.course-faq.page-title',
        },
      },

      // Course FAQ Editor
      {
        path: 'course-faq-add/:classSectionId/:courseOutlineId/:courseOutlineUnitId',
        name: 'course-faq-add',
        props: true,
        component: () => import('@/views/pages/Teacher/CourseFaq/Components/CourseFaqEditForm'),
        meta: {
          breadcrumb: [
            {title: 'Home', url: '/'},
            {
              title: {i18n: 'sections.course-faq.page-title', default: "FAQ ประจำวิชา"},
              url: 'course-faq/:classSectionId/:courseOutlineId',
              props: true,
            },
          ],
          pageTitle: 'sections.course-faq.add-page',
        },
      },
      {
        path: 'course-faq-edit/:classSectionId/:courseOutlineId/:courseOutlineUnitId/:id',
        name: 'course-faq-edit',
        props: true,
        component: () => import('@/views/pages/Teacher/CourseFaq/Components/CourseFaqEditForm'),
        meta: {
          breadcrumb: [
            {title: 'Home', url: '/'},
            {
              title: {i18n: 'sections.course-faq.page-title', default: "FAQ ประจำวิชา"},
              url: 'course-faq/:classSectionId/:courseOutlineId',
              props: true,
            },
          ],
          pageTitle: 'sections.course-faq.edit-page',
        },
      },

      // Webboard
      {
        path: 'web-board/:classSectionId',
        name: 'web-board',
        props: true,
        component: () => import('@/views/pages/Teacher/WebBoard/index.vue'),
        meta: {
          breadcrumb: [
            {title: 'Home', url: '/'},
            {
              title: {i18n: 'sections.web-board.page-title', default: "เว็บบอร์ด"},
              active: true
            }
          ],
          pageTitle: 'sections.web-board.page-title',
        },
      },

      // Private Messenging (PM)
      {
        path: '/pm',
        name: 'pm',
        component: () => import('@/views/pages/PM/index.vue'),
        meta: {
          breadcrumb: [
            { title: { i18n: 'sections.pm.title', default: "ข้อความ" }, url: '/', active: true }
          ],
          pageTitle: 'sections.pm.title',
        }
      },
      // UNIVERSITY NEWS
      {
        path: '/university-news',
        name: 'university-news',
        component: () => import('@/views/pages/UniversityNews/index.vue'),
        meta: {
          breadcrumb: [
            {title: 'Home', url: '/'},
            { title: { i18n: 'sections.university-news.title', default: "ข่าวสาร" }, active: true }
          ],
          pageTitle: 'sections.university-news.title',
        }
      },
      // INFO TOPIC CONTENT
      {
        path: 'info-topic-content/:id',
        name: 'info-topic-content',
        props: true,
        component: () => import('@/views/pages/UniversityNews/InfoTopicContent'),
        meta: {
          breadcrumb: [
            {title: 'Home', url: '/'},
            {title: {i18n: 'sections.university-news.title', default: "ข่าวสาร"}, url: "/university-news/info-topic"},
            {title: {i18n: 'sections.university-news.info-topic-content.title', default: "เนื้อหาข่าวสาร"}, active: true}
          ],
          pageTitle: 'sections.university-news.info-topic-content.title',
        },
      },

      // Personal Info
      {
        path: '/personal-info',
        name: 'personal-info',
        component: () => import('@/views/pages/PersonalInfo/index.vue'),
        children: [
          {
            path: 'teacher-profile/:id',
            name: 'personal-info-teacherprofile',
            props: true,
            component: () => import('@/views/pages/PersonalInfo/TeacherProfile/index.vue'),
            meta: {
              breadcrumb: [
                {title: 'Home', url: '/'},
                {title: {i18n: 'sections.personal-info.title', default: "ข้อมูลรายบุคคล"}},
                {
                  title: {i18n: 'sections.personal-info.teacher-profile.list.page-title', default: "รายชื่ออาจารย์"},
                  url: '/personal-info/teacher'
                },
                {
                  title: {i18n: 'sections.personal-info.teacher-profile.detail.page-title', default: "ข้อมูลอาจารย์"},
                  active: true
                }
              ],
              pageTitle: 'sections.personal-info.teacher-profile.detail.page-title',
            },
          },
        ]
      },

      // Course
      {
        path: '/courses',
        name: 'courses',
        component: () => import('@/views/pages/Courses/index.vue'),
        children: [
          {
            path: 'course-outline',
            name: 'course-outline',
            component: () => import('@/views/pages/Courses/CourseOutlineList.vue'),
            meta: {
              breadcrumb: [
                { title: 'Home', url: '/' },
                { title: { i18n: 'sections.courses.title', default: "จัดการรายวิชา" } },
                { title: { i18n: 'sections.courses.course-outline.list.page-title', default: "รายการรายวิชา" }, active: true }
              ],
              pageTitle: 'sections.courses.course-outline.list.page-title',
            },
          },
          {
            path: 'course-outline-edit/:id',
            name: 'course-outline-edit',
            props: true,
            component: () => import('@/views/pages/Courses/CourseOutline/EditCourseOutline'),
            meta: {
              breadcrumb: [
                { title: 'Home', url: '/' },
                { title: { i18n: 'sections.courses.title', default: "จัดการรายวิชา" } },
                {
                  title: {
                    i18n: 'sections.courses.course-outline.list.page-title',
                    default: "รายการรายวิชา"
                  },
                  url: "/courses/course-outline"
                },
                {
                  title: {
                    i18n: 'sections.courses.course-outline.edit.page-title',
                    default: "แก้ไขรายวิชาที่สอน"
                  }, active: true
                }
              ],
              pageTitle: 'sections.courses.course-outline.edit.page-title',
            },
          },
          {
            path: 'vdo-set-edit/:courseOutlineId',
            name: 'vdo-set-edit',
            props: true,
            component: () => import('@/views/pages/VdoSet/EditVdoSet.vue'),
            meta: {
              breadcrumb: [
                {title: 'Home', url: '/'},
                {title: {i18n: 'sections.courses.title', default: "จัดการรายวิชา"}},
                {
                  title: {
                    i18n: 'sections.courses.course-outline.list.page-title',
                    default: "รายการรายวิชา"
                  },
                  url: "/courses/course-outline"
                },
                {
                  title: {i18n: 'sections.courses.vdo-set.edit.page-title', default: "แก้ไขชุดวิดีโอ"},
                  active: true
                }
              ],
              pageTitle: 'sections.courses.vdo-set.edit.page-title',
            },
          },
          {
            path: 'vdo-live-set',
            name: 'vdo-live-set',
            component: () => import('@/views/pages/LiveClass/VdoLiveSet/index.vue'),
            meta: {
              breadcrumb: [
                {title: 'Home', url: '/'},
                {title: {i18n: 'sections.courses.title', default: "จัดการรายวิชา"}},
                {
                  title: {i18n: 'sections.courses.vdo-live-set.list.page-title', default: "วิดีโอบรรยายสด"},
                  active: true
                }
              ],
              pageTitle: 'sections.courses.vdo-live-set.list.page-title',
            },
          },
          {
            path: 'vdo-live-set-edit/:liveClassScheduleId',
            name: 'vdo-live-set-edit',
            props: true,
            component: () => import('@/views/pages/LiveClass/VdoLiveSet/EditVdoLiveSet.vue'),
            meta: {
              breadcrumb: [
                {title: 'Home', url: '/'},
                {title: {i18n: 'sections.courses.title', default: "จัดการรายวิชา"}},
                {
                  title: {
                    i18n: 'sections.courses.vdo-live-set.list.page-title',
                    default: "วิดีโอบรรยายสด"
                  },
                  url: "/courses/vdo-live-set"
                },
                {
                  title: {
                    i18n: 'sections.courses.vdo-live-set.edit.page-title',
                    default: "แก้ไขวิดีโอบรรยายสด"
                  }, active: true
                }
              ],
              pageTitle: 'sections.courses.vdo-live-set.edit.page-title',
            },
          },
        ]
      },

      // Examination
      {
        name: 'examination',
        path: '/examination',
        component: () => import('@/views/pages/Examination/index.vue'),
        children: [
          {
            path: 'exam',
            name: 'exam',
            component: () => import('@/views/pages/Examination/Main/index.vue'),
            meta: {
              breadcrumb: [
                { title: 'Home', url: '/' },
                { title: { i18n: 'sections.examination.title', default: "จัดการข้อสอบ" } },
                { title: { i18n: 'sections.examination.exam.list.page-title', default: "รายวิชาในคลังข้อสอบ" }, active: true }
              ],
              pageTitle: 'sections.examination.exam.list.page-title',
            },
          },
          {
            path: 'exam-by-subject/:id',
            name: 'exam-by-subject',
            props: true,
            component: () => import('@/views/pages/Examination/ExamBySubject/index.vue'),
            meta: {
              breadcrumb: [
                { title: 'Home', url: '/' },
                { title: { i18n: 'sections.examination.title', default: "จัดการข้อสอบ" } },
                { title: { i18n: 'sections.examination.exam.list.page-title', default: "รายวิชาในคลังข้อสอบ" }, url: "/examination/exam" },
                { title: { i18n: 'sections.examination.exam.subject.list.page-title', default: "รายการคำถามในรายวิชา" }, active: true }
              ],
              pageTitle: 'sections.examination.exam.subject.list.page-title',
            },
          },{
            path: 'exam-upload',
            name: 'exam-upload',
            component: () => import('@/views/pages/Examination/ExamUpload/index.vue'),
            meta: {
              breadcrumb: [
                { title: 'Home', url: '/' },
                { title: { i18n: 'sections.examination.title', default: "จัดการข้อสอบ" } },
                { title: { i18n: 'sections.examination.exam-upload.list.page-title', default: "อัพโหลดข้อสอบ" }, active: true }
              ],
              pageTitle: 'sections.examination.exam-upload.list.page-title',
            },
          },
        ]
      },

      // Advisor
      {
        name: 'advisor',
        meta: {
          breadcrumb: [
            { title: 'Advisor', url: '/' },
            {
              title: { i18n: 'sections.advisor.page-title', default: "Advisor"},
              active: true
            }
          ],
          pageTitle: 'sections.advisor.page-title',
        },
        path: '/advisor',
        component: () => import('@/views/pages/Advisor/index.vue'),
      },
      {
        name: 'live-class',
        path: '/live-class',
        component: () => import('@/views/pages/LiveClass'),
      },

      {
        path: '',
        component: () => import('@/views/pages/E-Learning/VirtualClass/index.vue'),
        // redirect: '/',
        // beforeEnter: AuthRequired,
        children: [
          {
            name: "virtual-class",
            path: "/e-learning/virtual-class/:classSectionId",
            props: true,
            component: () => import('@/views/pages/E-Learning/VirtualClass/index.vue'),
            breadcrumb: [
              { title: { i18n: 'sections.home.title', default: "Home" }, url: '/', active: true }
            ],
            pageTitle: 'Home',
          },
        ]
      },
    ],
  },
  // =============================================================================
  // FULL PAGE LAYOUTS
  // =============================================================================
  {
    path: '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children: [
      // =============================================================================
      // PAGES
      // =============================================================================
      {
        path: '/user',
        name: 'user',
        component: () => import('@/views/user'),
        redirect: '/user/login',
        children: [
          {
            path: 'login',
            name: 'user-login',
            component: () => import('@/views/user/Login')
          },
          {
            path: 'register',
            name: 'user-register',
            component: () => import('@/views/user/Register')
          },
          {
            path: 'forgot-password',
            name: 'user-forgot-password',
            component: () => import('@/views/user/ForgotPassword')
          },
          {
            path: 'change-password',
            name: 'user-change-password',
            props: true,
            component: () => import('@/views/user/ChangePassword')
          },
        ]
      },
      {
        path: '/pages/error-404',
        name: 'page-error-404',
        component: () => import('@/views/pages/Error404.vue')
      },
    ]
  },
  // Redirect to 404 page, if no match found
  {
    path: '*',
    redirect: '/pages/error-404'
  }
];

router.addRoutes(routes);

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router
